import Vue from "vue";

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
    dsn: 'https://a7066064196942c0823185c4e35b6565@o300522.ingest.sentry.io/1724354',
    integrations: [new VueIntegration({Vue, attachProps: true})],
});

import App from "./App.vue";
import store from './store';
import router from "./routes";

import "./styles/styles.scss";
import "./scripts/buefy";
import './scripts/helpers/numberFormat';
import "./scripts/filters/moneyFormat";
import "./scripts/VueMoment";

Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
